import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const childrenCountState = atom({
  key: "childrenCountState",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});

// Deprecated: Use childrenCountState instead
export const threeOrFourChildrenState = childrenCountState;
